module.exports = __webpack_public_path__ + "img/bck-arrow.61eefa32.svg";